
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HomepageComponent } from './homepage/homepage.component';
import { ResultpageComponent } from './resultpage/resultpage.component';
import { ReportComponent } from './report/report.component';

const routes: Routes = [
  { path: '', redirectTo: '/homepage', pathMatch: 'full' },
  // { path: '', redirectTo: '/reportpage', pathMatch: 'full' },
  { path: 'homepage', component: HomepageComponent },
  { path: 'resultpage', component: ResultpageComponent },
  { path: 'reportpage', component: ReportComponent },

];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
